import React, {Suspense} from 'react'
import ReactDOM from 'react-dom'
import App from './App';

import "current-device";
import './i18n'
import './style/main.scss'

ReactDOM.render(
    <Suspense fallback={<div></div>}>
        <App/>
    </Suspense>,
    document.getElementById('root')
);
